import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';

import type { ConversationTakeoverResult } from '../types';

export const ACTIVE_TAKEOVER_KEY = 'active-takeover';

/**
 * Item 332 — busca o takeover ATIVO da conversa (fallback de deep-link/refresh
 * da Tela 3 Intervenção, quando NÃO há o nav state vindo da Tela 2).
 *
 * Gatear o fetch, não só o render: a query só dispara quando `enabled` é true —
 * o caller passa `canForce && navTakeover === null && conversationId` para evitar
 * disparar o GET (gated por `force-takeover`) sem a cap ou quando o nav state já
 * trouxe o takeover. Sem polling: no deep-link basta o fetch inicial. Após
 * return/transfer a Tela 3 NAVEGA para fora (não permanece para servir cache
 * stale); o `staleTime` default (0) ainda re-busca em remontagem por garantia.
 */
export function useActiveTakeover(
  conversationId: string | undefined,
  opts: { enabled: boolean },
): UseQueryResult<ConversationTakeoverResult | null> {
  return useQuery<ConversationTakeoverResult | null>({
    queryKey: [ACTIVE_TAKEOVER_KEY, conversationId],
    enabled: opts.enabled && conversationId !== undefined,
    queryFn: async () => api.getActiveTakeover(conversationId!),
  });
}
